import { cn } from "@/lib/utils";
import ServiceIcon from "./ServiceIcon";
import { matchService } from "./serviceIcons";

// Иконка мерчанта в списке операций.
//
// Тянуть её из интернета по ходу списка — плохой размен: это внешний запрос на
// каждую строку, утечка того, где человек платит, и пустые квадраты без сети.
// Поэтому набор локальный, а всё незнакомое получает монограмму.

// Цвет монограммы выводим из имени, а не берём случайный: один и тот же
// мерчант обязан выглядеть одинаково в каждом списке и при каждом заходе.
const hueOf = (name) => {
  let hash = 0;
  const value = String(name || "");
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % 360;
  }
  return hash;
};

// Первые буквы двух первых значимых слов. Служебный мусор эмитента — коды
// вида 4367 и страну в конце — в монограмму не тащим.
const monogramOf = (name) => {
  const words = String(name || "")
    .replace(/[^\p{L}\p{N}\s]+/gu, " ")
    .split(/\s+/)
    .filter((word) => word && !/^\d+$/.test(word));
  if (!words.length) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

export { matchService as matchBrand };

const MerchantIcon = ({ name, className }) => {
  const slug = matchService(name);
  if (slug) return <ServiceIcon slug={slug} className={cn("h-full w-full", className)} />;

  const hue = hueOf(name);
  return (
    <span
      className={cn("flex h-full w-full items-center justify-center text-[11px] font-bold text-white", className)}
      style={{ background: `linear-gradient(140deg, hsl(${hue} 62% 48%), hsl(${(hue + 26) % 360} 58% 36%))` }}
      aria-hidden="true"
    >
      {monogramOf(name)}
    </span>
  );
};

export default MerchantIcon;
